import Mutations from '../../odata/mutations';

export default { ...new Mutations('message'), ...new Mutations('messages') };
